import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const GoogleSheetData = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const SERVER_URL = process.env.NODE_ENV === 'production'
        ? 'https://aqueous-atoll-11213.herokuapp.com'
        : 'http://localhost:5001';

    useEffect(() => {
        async function checkAuth() {
            try {
                // 1. Проверяем авторизацию
                const authResponse = await fetch("/api/auth-status");
                const authData = await authResponse.json();

                if (!authData.authenticated) {
                    const serverUrl = SERVER_URL || window.location.origin; // Определяем сервер
                    const redirectUri = encodeURIComponent(window.location.href); // Текущая страница
                    window.location.href = `${serverUrl}/auth/google?redirect=${redirectUri}`; // Отправляемся на сервер!
                    return;
                }

                // 2. Если авторизован — загружаем данные с Google Sheets
                const sheetsResponse = await fetch("/api/google-sheets");
                const sheetsData = await sheetsResponse.json();

                setData(sheetsData);
            } catch (error) {
                console.error("Помилка завантаження даних:", error);
            } finally {
                setLoading(false);
            }
        }

        checkAuth();
    }, []);

    if (loading) return <p>Завантаження даних…</p>;

    return (
        <div>
            <h2>Данные из Google Таблицы</h2>
            <table border="1">
                <thead>
                <tr>
                    {data[0]?.map((header, index) => (
                        <th key={index}>{header}</th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {data.slice(1).map((row, rowIndex) => (
                    <tr key={rowIndex}>
                        {row.map((cell, cellIndex) => (
                            <td key={cellIndex}>{cell}</td>
                        ))}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default GoogleSheetData;
